module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/imovelweb_mobile.1374fb7c.svg";